<div class="flex flex-col h-full">
    <div class="grid grid-cols-1 lg:grid-cols-1 items-start gap-8 flex-1 overflow-y-auto">
        @if(!_orderWizardService.loading$() && pickupPoint) {
            <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
        }
        @else {
            <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
        }
    </div>
</div>

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<ng-template #component_loaded>
    <corp-card [corp-content]="tp_corp_card_pickup_point"></corp-card>
</ng-template>

<ng-template #tp_corp_card_pickup_point>
    <div class="corp-card">
        <div class="corp-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
            <h5 class="!mb-0">
                <!-- Pickup point -->
                {{ 'i18n.app.features.pages.order.wizard.step_02.pickup-point-card-summary.h5_01' | translate }}
            </h5>
            
            <div 
                class="h-10 w-10 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary text-white">
                <span class="material-symbols-outlined text-2xl leading-none">
                    route
                </span>
            </div>
        </div>

        <div class="corp-card-content">
            <div class="grid grid-cols-2 lg:grid-cols-2 gap-8 items-stretch ">
                <div>
                    <div class="block relative inline-block">
                        <img src="images/card/{{pickupPoint?.place?.code?.toLowerCase()}}.png" 
                            class="rounded-[5px]" 
                            alt="property-image">
                        <span class="material-symbols-outlined 
                                    absolute top-0 left-0 
                                    m-2 p-1/2 
                                    bg-white rounded-sm shadow-md">
                            person_pin_circle
                        </span>
                    </div>
                </div>
                <div class="h-full flex flex-col">
                    <span class="block relative pt-px ltr:pl-[22px] rtl:pr-[22px] text-md">
                        <i class="material-symbols-outlined text-primary-500 absolute ltr:-left-[2px] rtl:-right-[2px] top-1/2 -translate-y-1/2 !text-[19px]">
                            location_on
                        </i>
                        <h5 class="!mb-0">
                            {{ pickupPoint?.place?.label }}
                        </h5><br>
                        {{ pickupPoint?.address?.streetName }} {{ pickupPoint?.address?.streetNumber }} <br>
                        {{ pickupPoint?.address?.postalCode }} {{ pickupPoint?.address?.city }} <br>
                        {{ pickupPoint?.address?.state }}
                    </span>
                    <div class="mt-auto flex justify-end items-center">
                        <!-- <span class="inline-block text-xs rounded-[4px] bg-secondary-100 text-secondary-600 dark:bg-[#15203c] text-xs py-px px-[9px] mr-2">
                            i18n: Agency Code
                            {{ 'i18n.app.features.pages.order.wizard.step_02.pickup-point-card-summary.span_01' | translate }}
                        </span> 
                        <div class="!mb-0 !text-secondary-500">
                            {{ pickupPoint?.place?.code }}
                        </div>  -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

   
        <!-- ======== -->
        <!-- TEMPLATES -->
        <!-- ======= -->
            
        <ng-template #tp_corp_card_content >
            <div 
                class="trezo-card bg-white dark:bg-[#0c1427] p-[5px] md:p-[10px] rounded-md cursor-pointer relative transition-all duration-300"
                >

                    <div class="trezo-card-header mb-[20px] flex items-center justify-between">
                        <div class="trezo-card-title">
                            <h5 class="!mb-0">
                                {{ pickupPoint?.place?.label }}
                            </h5>
                        </div>
                    </div>
                    <div class="trezo-card-content">
                        <div class="block relative inline-block">
                            <img src="images/card/{{pickupPoint?.place?.code?.toLowerCase()}}.png" 
                                class="rounded-[5px]" 
                                alt="property-image">
                            <span class="material-symbols-outlined 
                                        absolute top-0 left-0 
                                        m-2 p-1/2 
                                        bg-white rounded-sm shadow-md">
                                person_pin_circle
                            </span>
                        </div>
                        <div class="flex items-center justify-between mb-[9px] mt-[20px]">

                        </div>
                        <span class="block relative pt-px ltr:pl-[22px] rtl:pr-[22px]">
                            <i class="material-symbols-outlined text-primary-500 absolute ltr:-left-[2px] rtl:-right-[2px] top-1/2 -translate-y-1/2 !text-[19px]">
                                location_on
                            </i>
                            {{ pickupPoint?.address?.streetNumber }} {{ pickupPoint?.address?.streetType?.label }} {{ pickupPoint?.address?.streetName }} <br>
                            {{ pickupPoint?.address?.postalCode }} {{ pickupPoint?.address?.city }} <br>
                            {{ pickupPoint?.address?.state }} 

                        </span>
                        <div class="mt-[20px] flex items-center justify-end">
                            <span class="inline-block text-xs rounded-[4px] bg-secondary-100 text-secondary-600 dark:bg-[#15203c] text-xs py-px px-[9px] mr-2">
                                <!-- i18n: Agency Code -->
                                {{ 'i18n.app.features.pages.order.wizard.step_02.pickup-point-card-summary.span_02' | translate }}
                            </span> 
                            <div class="!mb-0 !text-secondary-500">
                                {{ pickupPoint?.place?.code }}
                            </div>
                        </div> 

                    </div>
            </div>
        </ng-template>
